// extracted by mini-css-extract-plugin
module.exports = {"container":"container--NoPosts-NoResults-components__retMT"};